module.exports = __webpack_public_path__ + "static/img/品牌美学.8af99035.png";